import { BottomNavigation, BottomNavigationAction, Box, Grid, Paper } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { PageWrapper } from '../../components/page/PageWrapper';
import { ResultsList } from './game/gameresult/ResultsList';
import { Challenge } from './challenges/Challenge';
import { useTenantState } from '../../api/tenants/useTenant';
import { cupAuthService } from '../../auth/cupAuthService';
import { TitledCard } from '../../components/layout/TitledCard';
import { CupStatistics } from './statistics/CupStatistics';
import { ChallengesList } from './challenges/ChallengesList';
import ChangeHistoryIcon from '@material-ui/icons/ChangeHistory';
import SportsHockeyIcon from '@material-ui/icons/SportsHockey';
import ReorderIcon from '@material-ui/icons/Reorder';
import BarChartIcon from '@material-ui/icons/BarChart';
import HistoryIcon from '@material-ui/icons/History';
import { useIsMobile } from '../../hooks/useIsMobile';
import { useTheme } from '@material-ui/core/styles';
import { Pyramid } from './pyramid/Pyramid';
import { Timeline } from './timeline/Timeline';
import { AppInstallBanner } from '../../components/AppInstallBanner';

enum NavigationAction {
  FORDERN = 'Fordern',
  RANGLISTE = 'Rangliste',
  ERGEBNISSE = 'Ergebnisse',
  STATISTIK = 'Statistik',
  NOTIFICATIONS = 'Verlauf',
}

const navigationActions = [
  NavigationAction.FORDERN,
  NavigationAction.RANGLISTE,
  NavigationAction.ERGEBNISSE,
  NavigationAction.STATISTIK,
  NavigationAction.NOTIFICATIONS,
];

export const HomePage = () => {
  const { tenant, isError, error } = useTenantState();
  const [currentNavigation, setCurrentNavigation] = useState(NavigationAction.FORDERN);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (isError) {
      cupAuthService().logoutAndNavigateToStart();
    }
  }, [tenant, isError, error]);

  const handleNavigationChange = (newAction: NavigationAction) => {
    setCurrentNavigation(newAction);
  };

  if (!tenant) {
    return null;
  }
  return (
    <>
      <AppInstallBanner />
      <div style={{ paddingBottom: isMobile ? '56px' : 0 }}>
        <PageWrapper title={tenant.name} subtitle={tenant.tenantKey}>
          <Grid container spacing={4}>
            {(!isMobile || currentNavigation === NavigationAction.FORDERN) && (
              <Grid item xs={12}>
                <Paper>
                  <Challenge startTimestamp={tenant.startTimestamp} tenantStatus={tenant.status} tenant={tenant} />
                </Paper>
              </Grid>
            )}
            {(!isMobile || currentNavigation === NavigationAction.RANGLISTE) && (
              <Grid item xs={12}>
                <TitledCard title={'Rangliste'}>
                  <Box display="flex" width="100%">
                    <Pyramid />
                  </Box>
                </TitledCard>
              </Grid>
            )}
            {(!isMobile || currentNavigation === NavigationAction.FORDERN) && (
              <Grid item xs={12} md={4}>
                <TitledCard title={'Offene Forderungen'}>
                  <Box display="flex" width="100%">
                    <ChallengesList />
                  </Box>
                </TitledCard>
              </Grid>
            )}
            {(!isMobile || currentNavigation === NavigationAction.ERGEBNISSE) && (
              <Grid item xs={12} md={4}>
                <TitledCard title={'Ergebnisse'}>
                  <Box display="flex" width="100%">
                    <ResultsList />
                  </Box>
                </TitledCard>
              </Grid>
            )}
            {(!isMobile || currentNavigation === NavigationAction.STATISTIK) && (
              <Grid item xs={12} md={4}>
                <TitledCard title={'Statistiken'}>
                  <Box display="flex" width="100%">
                    <CupStatistics />
                  </Box>
                </TitledCard>
              </Grid>
            )}
            {isMobile && currentNavigation === NavigationAction.NOTIFICATIONS && (
              <Grid item xs={12} md={4}>
                <TitledCard title={'Verlauf'}>
                  <Box display="flex" width="100%">
                    <Timeline />
                  </Box>
                </TitledCard>
              </Grid>
            )}
          </Grid>
        </PageWrapper>
      </div>
      {isMobile && <SimpleBottomNavigation onNavigate={handleNavigationChange} />}
    </>
  );
};

// Define the enum for navigation actions

interface SimpleBottomNavigationProps {
  onNavigate: (action: NavigationAction) => void; // Expecting enum value
}

const SimpleBottomNavigation: React.FC<SimpleBottomNavigationProps> = ({ onNavigate }) => {
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const backgroundColor = theme.palette.primary.main;
  const iconColor = theme.palette.common.white;
  const selectedIconColor = theme.palette.secondary.main;

  const handleChange = (event: React.MouseEvent<HTMLElement>, newIndex: number) => {
    const newValue = navigationActions[newIndex]; // Get the corresponding enum value
    setValue(newIndex);
    if (onNavigate) {
      onNavigate(newValue);
    }
  };

  const getIconColor = (action: NavigationAction): string => {
    if (!action) {
      return iconColor;
    }
    if (action === navigationActions[value]) {
      return selectedIconColor;
    }
    return iconColor;
  };

  const x = { paddingLeft: 2, paddingRight: 2, minWidth: 72 };
  return (
    <BottomNavigation
      value={value}
      onChange={handleChange}
      showLabels
      style={{
        height: '56px',
        position: 'fixed',
        bottom: '0',
        width: '100%',
        background: backgroundColor,
      }}
    >
      <BottomNavigationAction
        label={NavigationAction.FORDERN}
        icon={<SportsHockeyIcon />}
        style={{ color: getIconColor(NavigationAction.FORDERN), ...x }}
      />
      <BottomNavigationAction
        label={NavigationAction.RANGLISTE}
        icon={<ChangeHistoryIcon />}
        style={{ color: getIconColor(NavigationAction.RANGLISTE), ...x }}
      />
      <BottomNavigationAction
        label={NavigationAction.ERGEBNISSE}
        icon={<ReorderIcon />}
        style={{ color: getIconColor(NavigationAction.ERGEBNISSE), ...x }}
      />
      <BottomNavigationAction
        label={NavigationAction.STATISTIK}
        icon={<BarChartIcon />}
        style={{ color: getIconColor(NavigationAction.STATISTIK), ...x }}
      />
      <BottomNavigationAction
        label={NavigationAction.NOTIFICATIONS}
        icon={<HistoryIcon />}
        style={{ color: getIconColor(NavigationAction.NOTIFICATIONS), ...x }}
      />
    </BottomNavigation>
  );
};
